function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import Teaser from "../molecules/Teaser";
export default function TeaserGrid(props) {
    var _props_teasers;
    var perPage = 6;
    var total = (_props_teasers = props.teasers) === null || _props_teasers === void 0 ? void 0 : _props_teasers.length;
    var _useState = _sliced_to_array(useState(1), 2), page = _useState[0], setPage = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), teasers = _useState1[0], setTeasers = _useState1[1];
    useEffect(function() {
        // If we have loadMore enable, only show first set of teasers
        if (props.loadMore) {
            setTeasers(props.teasers.slice(0, perPage));
        } else {
            setTeasers(props.teasers);
        }
    }, []);
    // On loadMore, append the next set of teasers
    var onLoadMore = function() {
        // Append the next set of teasers to teaser array
        setTeasers(teasers.concat(props.teasers.slice(perPage * page, perPage * (page + 1))));
        setPage(page + 1);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("px-6 md:px-14 mb-12 md:mb-24 pt-12 md:pt-16 container-alt", {
            "lg:pt-20": !props.svgBg,
            "lg:pt-24": !props.gridHeading && !props.svgBg,
            "pt-4 md:pt-12 lg:pt-0": props.svgBg === true
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mx-auto max-w-7xl", {
            "relative z-10 lg:pb-8": props.svgBg === true
        })
    }, props.gridHeading ? /*#__PURE__*/ React.createElement("h2", {
        className: "mx-auto max-w-3xl text-center block font-heading text-2xl md:text-3xl lg:text-4xl md:leading-tight mb-9 md:mb-16"
    }, props.gridHeading) : null, /*#__PURE__*/ React.createElement("div", {
        className: "grid lg:grid-cols-3 gap-4 md:gap-7"
    }, teasers.map(function(teaser, index) {
        var _teaser_logo;
        /*#__PURE__*/ return React.createElement("div", {
            key: index,
            className: "border bg-white overflow-hidden max-[1023px]:rounded-l-3xl lg:[&:nth-child(3n+1)]:rounded-l-3xl lg:[&:nth-child(3n+3)]:rounded-r-3xl"
        }, teaser && /*#__PURE__*/ React.createElement(Teaser, _object_spread_props(_object_spread({}, teaser), {
            logo: ((_teaser_logo = teaser.logo) === null || _teaser_logo === void 0 ? void 0 : _teaser_logo.length) ? teaser.logo : undefined,
            image: teaser.image ? teaser.image : undefined,
            alignBottom: props.alignBottom
        })));
    })), props.loadMore && total > teasers.length ? /*#__PURE__*/ React.createElement("div", {
        className: "text-center mt-10 md:mt-12 lg:mt-20 w-full"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "button-secondary w-full sm:w-[calc(33.33%-20px)] text-gray-200 border-gray-600 focus px-3 1.5lg:px-4 py-2 hover:text-white hover:bg-gray-600",
        onClick: onLoadMore
    }, "Load more")) : null), props.svgBg === true ? /*#__PURE__*/ React.createElement(CenteredGreySvg, null) : null);
}
function CenteredGreySvg() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1966px",
        height: "1448px",
        viewBox: "0 0 1966 1448",
        version: "1.1",
        className: "absolute -bottom-14 right-0"
    }, /*#__PURE__*/ React.createElement("title", null, "BG Pattern"), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("rect", {
        id: "path-1",
        x: "-8.61214235e-15",
        y: "0",
        width: "485",
        height: "824"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Thank-You-Page:-Demo",
        transform: "translate(526.000000, 624.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "BG-Pattern",
        transform: "translate(-526.000000, -624.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Angle-Pattern",
        transform: "translate(1723.500000, 1036.000000) scale(1, -1) rotate(-180.000000) translate(-1723.500000, -1036.000000) translate(1481.000000, 624.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pattern",
        transform: "translate(242.500000, 412.000000) scale(1, -1) translate(-242.500000, -412.000000) translate(0.000000, -0.000000)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Panel-Mask"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M-322.984141,-346 L475,349.310968 L463.483995,353.265679 L172.889,453.009 L31.011,518.604 L-67.922,586.363 L-124.067,656.513 L-159.618041,854 L-232.679,792.217 L-250.643392,814.663221 L-272.559,758.493 L-293.449,740.828 L-342.497352,774.422878 L-348.673,694.144 L-434.309392,733.737477 L-427.528,659.096 L-526,692.896202 L-322.984141,-346 Z M-128.383,661.906 L-230.62,789.644 L-161.847335,847.79994 L-128.383,661.906 Z M-262.971,766.601 L-248.836719,802.828483 L-237.25,788.351 L-262.971,766.601 Z M-121.375,622.973 L-277.333,729.79 L-265.482,760.164 L-235.191,785.779 L-126.159,649.55 L-121.375,622.973 Z M-339.367,701.998 L-334.999544,758.76469 L-300.324,735.014 L-339.367,701.998 Z M-282.403,733.263 L-290.631,738.898 L-275.071,752.056 L-282.403,733.263 Z M-305.46,674.165 L-340.27,690.259 L-339.722,697.387 L-297.506,733.085 L-285.642,724.959 L-305.46,674.165 Z M-114.715,585.978 L-300.017,671.649 L-280.572,721.487 L-119.215,610.974 L-114.715,585.978 Z M-400.906,649.959 L-415.745,655.052 L-421.204745,715.150514 L-358.239,686.039 L-400.906,649.959 Z M-353.329,633.628 L-397.28,648.714 L-354.943,684.515 L-349.604,682.047 L-353.329,633.628 Z M-325.061,623.926 L-344.85,630.718 L-341.2,678.161 L-309.601,663.552 L-325.061,623.926 Z M-360.146,-82.518 L-507.5291,671.687881 L-426.134,643.749 L-424.858,629.704 L-459.629475,600.300253 L-456.947487,599.336757 L-420.92,586.368 L-405.581,417.545 L-426.570087,363.747466 L-401.047,367.645 L-386.287,205.19 L-392.306857,126.932155 L-379.724,132.962 L-360.146,-82.518 Z M-108.143,549.47 L-319.395,621.981 L-304.158,661.035 L-112.255,572.312 L-108.143,549.47 Z M-84.886,597.982 L-117.559,620.36 L-121.843,644.157 L-84.886,597.982 Z M-414.256,638.67 L-414.35,639.704 L-413.413,639.382 L-414.256,638.67 Z M-358.426,567.374 L-409.447,585.739 L-413.892,634.667 L-409.787,638.138 L-354.443,619.142 L-358.426,567.374 Z M-421.249,589.987 L-453.1496,601.470897 L-424.494,625.702 L-421.249,589.987 Z M-348.517,563.807 L-349.958,564.326 L-345.965,616.231 L-330.177,610.812 L-348.517,563.807 Z M-94.24654,472.282129 L-342.883,561.779 L-324.511,608.867 L-105.289,533.622 L-94.24654,472.282129 Z M-52.113,557.035 L-111.066,584.291 L-115.399,608.361 L-66.251,574.7 L-52.113,557.035 Z M-396.322,441.279 L-409.118,582.12 L-358.688,563.967 L-361.201,531.297 L-396.322,441.279 Z M-22.543,520.089 L-104.577,548.246 L-108.605,570.625 L-36.196,537.148 L-22.543,520.089 Z M-16.251,540.455 L-39.946,551.41 L-49.288,563.082 L-16.251,540.455 Z M-350.362,559.078 L-350.22,560.919 L-349.715,560.737 L-350.362,559.078 Z M-364.189,379.329 L-351.94,538.565 L-344.08,558.709 L-89.9959594,467.252485 L-101.724,532.398 L-6.134,499.588 L40.6344959,441.154897 L-364.189,379.329 Z M49.678,495.3 L-11.975,516.462 L-24.029,531.523 L40.037,501.903 L49.678,495.3 Z M-390.33,375.337 L-395.108,427.92 L-362.779,510.783 L-372.994,377.984 L-390.33,375.337 Z M-369.623,147.427 L-376.341,221.361 L-364.66,373.202 L51.7846093,436.799564 L4.433,495.961 L93.201,465.492 L175.889397,408.8593 L-369.623,147.427 Z M-348.14315,-88.9797448 L-368.785,138.205 L193.191313,407.526174 L123.986,454.925 L192.547,431.392 L311.549148,376.374559 L-348.14315,-88.9797448 Z M-417.225508,371.229377 L-404.368,404.186 L-401.59,373.617 L-417.225508,371.229377 Z M-313.855543,-319.394913 L-355.192,-107.866 L334.192939,378.433042 L297.74,395.286 L447.402552,343.91648 L-313.855543,-319.394913 Z M-381.053,273.227 L-389.788,369.364 L-373.466,371.857 L-381.053,273.227 Z M-382.502978,141.254938 L-381.574,153.325 L-380.562,142.184 L-382.502978,141.254938 Z",
        id: "Combined-Shape",
        fill: "#F0F2F2",
        fillRule: "nonzero",
        mask: "url(#mask-2)"
    }))))))));
}
